module.exports = __webpack_public_path__ + "resources/img/img_db-i_cloud01-m-en.fad99ff68ae8f735a7a183e1752f4e5f.png";